import CryptoJS from 'crypto-js'

/* const isWebCryptoAvailable = () => {
  return !!(window.crypto && window.crypto.subtle)
} */

export const generateKey = async (password: string): Promise<CryptoKey | string> => {
  /* if (isWebCryptoAvailable()) {
    const encoder = new TextEncoder()
    const keyMaterial = await crypto.subtle.importKey('raw', encoder.encode(password), { name: 'PBKDF2' }, false, ['deriveKey'])

    return crypto.subtle.deriveKey({ name: 'PBKDF2', salt: encoder.encode('fixed-salt'), iterations: 100000, hash: 'SHA-256' }, keyMaterial, { name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt'])
  } */

  return password
}

export const encryptData = async (data: string, key: CryptoKey | string): Promise<string> => {
  /* if (isWebCryptoAvailable() && key instanceof CryptoKey) {
    const iv = crypto.getRandomValues(new Uint8Array(12))
    const encoded = new TextEncoder().encode(data)
    const encrypted = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, encoded)

    return JSON.stringify({ iv: Array.from(iv), encrypted: btoa(String.fromCharCode(...new Uint8Array(encrypted))) })
  } */

  return CryptoJS.AES.encrypt(data, key as string).toString()
}

export const decryptData = async (encryptedData: string, key: CryptoKey | string): Promise<string> => {
  /* if (isWebCryptoAvailable() && key instanceof CryptoKey) {
    try {
      const { iv, encrypted } = JSON.parse(encryptedData)
      const decrypted = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv: new Uint8Array(iv) },
        key,
        Uint8Array.from(atob(encrypted), (c) => c.charCodeAt(0))
      )

      return new TextDecoder().decode(decrypted)
    } catch (error) {
      console.error('Web Crypto decryption error:', error)
      throw error
    }
  } */

  return CryptoJS.AES.decrypt(encryptedData, key as string).toString(CryptoJS.enc.Utf8)
}

export const handleEncryptMessage = async (messageToEncrypt: string, secret: string) => {
  if (!secret) return

  const key = await generateKey(secret)
  const encrypted = await encryptData(messageToEncrypt, key)

  return encrypted
}

export const handleDecryptMessage = async (encryptedMessage: string, secret: string) => {
  if (!secret || !encryptedMessage) return

  const key = await generateKey(secret)
  const decrypted = await decryptData(encryptedMessage, key)

  return decrypted
}

export const encryptForServer = async (payload: Record<string, unknown>, secret: string): Promise<{ iv: string; cipherText: string }> => {
  const encoder = new TextEncoder()
  const secretHash = await crypto.subtle.digest('SHA-256', encoder.encode(secret))

  const iv = crypto.getRandomValues(new Uint8Array(16))
  const key = await crypto.subtle.importKey('raw', secretHash, { name: 'AES-CBC' }, false, ['encrypt'])
  const encrypted = await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, key, encoder.encode(JSON.stringify({ ...payload, timestampOfData: Date.now() })))

  return {
    iv: btoa(String.fromCharCode(...iv)),
    cipherText: btoa(String.fromCharCode(...new Uint8Array(encrypted)))
  }
}
